import React from 'react'
import { gql, useMutation } from 'urql'
import FormDialog from '../dialogs/FormDialog'
import { nonFieldErrors } from '../util/errutil'

const mutation = gql`
  mutation ($serviceID: ID!, $id: ID!) {
    unlinkSlackList(serviceID: $serviceID, id: $id)
  }
`

export default function ServiceSlackListDeleteDialog(props: {
  serviceID: string
  id: string
  name: string
  onClose: () => void
}): JSX.Element {
  const { serviceID, id, name, onClose } = props
  const [{ fetching, error }, unlinkSlackList] = useMutation(mutation)

  return (
    <FormDialog
      title='Are you sure?'
      confirm
      subTitle={`This will remove the Slack List "${name}" from this service.`}
      loading={fetching}
      errors={nonFieldErrors(error)}
      onClose={onClose}
      onSubmit={() => {
        unlinkSlackList(
          { serviceID, id },
          { additionalTypenames: ['SlackList', 'Service'] },
        ).then((result) => {
          if (!result.error) {
            onClose()
          }
        })
      }}
    />
  )
}
